import { useTranslation } from "react-i18next";
import { Col, Label, Row } from "reactstrap";
import CopyWrapper from "components/Common/CopyWrapper";
import { COLOR_PLAN_PURCHASE_INVOICE_TYPE, LIST_PLAN_PURCHASE_INVOICE_TYPE } from "helpers/constans";

export default function TransferSection({ dataFormat }: any) {
  const { t, i18n } = useTranslation();


  return (
    <>
      <Col md={4} lg={4}>
        <div className="mb-3 mt-2">
          <Label
            htmlFor="address"
            className="form-label"
          >
            {t("Depositor's Name")}
          </Label>
          <div className="cursor-pointer">
            <CopyWrapper
              contentCopy={dataFormat?.depositorsName}
            >
              {dataFormat?.depositorsName || "-"}
            </CopyWrapper>
          </div>
        </div>
      </Col>
      
      <Col md={4} lg={4}>
      </Col>
      <Col md={4} lg={4}>
        <div className="mb-3 mt-2">
          <Label
            htmlFor="manufacturer"
            className="form-label"
          >
            {t("Bank Name")}
          </Label>
          <div className="cursor-pointer">
            <CopyWrapper
              contentCopy={dataFormat?.bankName}
            >
              {dataFormat?.bankName || "-"}
            </CopyWrapper>
          </div>
        </div>
      </Col>

      <Col md={4} lg={4}>
        <div className="mb-3 mt-2">
          <Label
            htmlFor="accountNumber"
            className="form-label"
          >
            {t("Account Number")}
          </Label>
          <div className="cursor-pointer">
            <CopyWrapper
              contentCopy={dataFormat?.accountNumber}
            >
              {`${dataFormat?.accountNumber || "-"}`}
            </CopyWrapper>
          </div>
        </div>
      </Col>

      <Col md={4} lg={4}>
        <div className="mb-3 mt-2">
          <Label
            htmlFor="accountName"
            className="form-label"
          >
            {t("Account Name")}
          </Label>
          <div className="cursor-pointer">
            <CopyWrapper
              contentCopy={dataFormat?.accountName}
            >
              {`${dataFormat?.accountName || "-"}`}
            </CopyWrapper>
          </div>
        </div>
      </Col>

      <Col md={4} lg={4}>
        <div className="mb-3 mt-2">
          <Label
            htmlFor="receiptType"
            className="form-label"
          >
            {t("Receipt Type")}
          </Label>
          <div className="cursor-pointer">
            {
              dataFormat?.receiptType ? (
                <span
                  className={`rounded-pill badge bg-${
                    COLOR_PLAN_PURCHASE_INVOICE_TYPE[dataFormat?.receiptType] || "secondary"
                  }`}
                  style={{
                    fontSize: "0.8rem",
                    lineHeight: 1
                  }}
                >
                  {t(
                    LIST_PLAN_PURCHASE_INVOICE_TYPE?.find(
                      (item: any) => (item?.value) == (dataFormat?.receiptType)
                    )?.label || ""
                  )}
                </span>
              ) : "-"
            }
          </div>
        </div>
      </Col>

      <Col md={4} lg={4}>
        <div className="mb-3 mt-2">
          <Label
            htmlFor="receiptEmail"
            className="form-label"
          >
            {t("Receipt Email")}
          </Label>
          <div className="cursor-pointer">
            <CopyWrapper
              contentCopy={dataFormat?.receiptEmail}
            >
              {`${dataFormat?.receiptEmail || "-"}`}
            </CopyWrapper>
          </div>
        </div>
      </Col>

      <Col md={12} lg={12}>
        <div className="mb-3 mt-2">
          <Label
            htmlFor="depositNote"
            className="form-label"
          >
            {t("Note Transfer")}
          </Label>
          <div className="cursor-pointer">
            <CopyWrapper
              contentCopy={dataFormat?.depositNote}
            >
              {`${dataFormat?.depositNote || "-"}`}
            </CopyWrapper>
          </div>
        </div>
      </Col>
    </>
  );
}
